import { Tooltip } from '@silverfort/sf-components';
import React from 'react';

interface Props {
    description: string;
}

const ExposureDescriptionColumn: React.FC<Props> = ({ description }) => {
    return (
        <div className="flex items-center w-full min-h-5">
            <Tooltip title={description}>
                <p className="text-sm truncate text-nowrap">{description}</p>
            </Tooltip>
        </div>
    );
};

export default ExposureDescriptionColumn;
